import {
    Typography,
    Chip,
    IconButton as UiIconButton,
    styled,
    styledForMobile,
    SIDEBAR_SPACING,
} from "@l2r-front/l2r-ui"

import { RoadInfoItem } from "../RoadInfoItem"
import { RoadwayYearSelector as L2RRoadwayYearSelector } from "../RoadwayYearSelector/RoadwayYearSelector"

export const Container = styled("div")(({ isMobile, theme }) => ({
    height: "100%",
    padding: isMobile && theme.spacing(0, 4),
}))

export const RoadwayTabPanelHeader = styled("div")(({ theme }) => ({
    display: "flex",
    height: 40,
    margin: theme.spacing(0, 0, 3, 0),
    alignItems: "center",
}))

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
}))

export const IconButton = styled(UiIconButton)(() => ({
    marginLeft: "auto",
}))

export const HeaderWrapper = styledForMobile("div")(({ theme, isMobile }) => ({
    margin: isMobile ? 0 : theme.spacing(0, SIDEBAR_SPACING, 5, SIDEBAR_SPACING),
}))

export const Count = styled(Chip)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    marginLeft: theme.spacing(3),
}))

export const YearSelector = styledForMobile(L2RRoadwayYearSelector)(({ isMobile, theme }) => ({
    paddingTop: !isMobile && theme.spacing(6),
    width: "100%",
}))

export const NetworkGradingSelectorDescription = styled(Typography)(({ theme }) => ({
    display: "block",
    paddingTop: theme.spacing(2),
    width: "100%",
}))

export const UGELogo = styled("img")(({ theme }) => ({
    padding: theme.spacing(2),
    height: "100%",
}))

export const MirandaInfoItem = styled(RoadInfoItem)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}))

export const RoadwaySidebarContainer = styled("div")(() => ({}))